module.exports = __webpack_public_path__ + "static/media/trygg-t.9382066b.mp3";